<div class="online-task-inspection-form">
  <div class="page-subheader">
    <div class="container">
      <div class="row title">
        <div class="col">
          <h1>
            <span class="">Pojistná událost</span>
            <span *ngIf="task && task.claimNumber !== null && task.claimNumber !== undefined && task.claimNumber !== ''"
              class="d-block claim-number">
              č. {{task.claimNumber}}
            </span>
          </h1>
        </div>
        <div class="col-12 col-sm-auto align-self-end d-flex justify-content-sm-end pt-3">
          <div *ngIf="task?.auth?.expiresIn" matTooltip="Platnost formuláře." class="me-3">
            <button mat-button type="button" class="text-muted">
              <mat-icon class="me-1">timer</mat-icon>
              <span>{{(task.auth.expiresIn / 60).toFixed(0)}} min.</span>
            </button>
          </div>

          <button
            *ngIf="showSentAttachmentButton() === true"
            type="button"
            class="confirm-online-inspection"
            [disabled]="isSubmittingOnlineInspection"
            (click)="onlineTaskInspectionDone()">
            <mat-icon>done</mat-icon>
            <span>{{
              isSubmittingOnlineInspection
              ? ('portal.onlineTaskInspection.submitting' | translate) + '…'
              : ('portal.onlineTaskInspection.submitDocuments' | translate) }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="task-detail">
    <div *ngIf="task" class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="card mat-elevation-z15">
            <div #alertsContainer>
              <div class="row info-row-padding" *ngIf="cantSendAlert === true">
                <ngb-alert [type]="'danger'" class="d-inline-block" [dismissible]="false">
                  {{"errors.cantSendAlert" | translate}}
                </ngb-alert>
              </div>
              <div class="row info-row-padding" *ngIf="showSentAttachmentButton() === true">
                <ngb-alert [type]="'info'" class="d-inline-block" [dismissible]="false">
                  {{"portal.onlineTaskInspection.info" | translate}}
                </ngb-alert>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mb-4 mb-md-5 col-xl-4 col-md-6">
                <div class="row">
                  <div class="col-auto">
                    <mat-icon class="icon">assignment</mat-icon>
                  </div>
                  <div class="col ps-4 pt-2">
                    <div class="card-subtitle">Číslo události</div>
                    <div class="card-title">č. {{(task.claimNumber && task.claimNumber !== '') ? task.claimNumber :
                      'neuvedeno'}}</div>
                  </div>
                </div>
              </div>
              <div class="col-12 mb-4 mb-md-5 col-xl-4 col-md-6">
                <div class="row">
                  <div class="col-auto">
                    <mat-icon class="icon">directions_car</mat-icon>
                  </div>
                  <div class="col ps-4 pt-2">
                    <div class="card-subtitle">RZ vozidla</div>
                    <div class="card-title">{{(task.carLicensePlate && task.carLicensePlate !== '') ?
                      task.carLicensePlate : 'neuvedeno'}}</div>
                  </div>
                </div>
              </div>
              <div class="col-12 mb-4 mb-md-5 col-xl-auto col-md-12">
                <div class="row">
                  <div class="col-auto">
                    <mat-icon class="icon">business</mat-icon>
                  </div>
                  <div class="col ps-4 pt-2">
                    <div class="card-subtitle">Pojišťovna</div>
                    <div class="card-title">{{(task.partner && task.partner.name !== null && task.partner.name !==
                      undefined) ? task.partner.name : 'neuvedeno'}}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-4 mb-md-5" *ngIf="task.portalShowRequiredDocumentsGroup && canUploadFiles()">
              <div class="col-12">
                <div class="row">
                  <div class="col-auto">
                    <mat-icon class="icon">rule</mat-icon>
                  </div>
                  <div class="col ps-4 pt-1">
                    <div class="card-subtitle">
                      {{"portal.onlineTaskInspection.requiredDocumentsTitle" | translate}} <br>
                      <span class="small d-flex" *ngIf="task.anyTaskFilesInPending"><mat-icon inline class="fs-6 me-1">info</mat-icon><span>{{"portal.onlineTaskInspection.requiredDocumentsPendingInfo" | translate}}</span></span>
                    </div>
                    <div class="required-documents-grid mt-2">
                      <div class="required-document-item" *ngFor="let requiredDocument of task.requiredDocuments">
                        <mat-icon
                          *ngIf="requiredDocument.status === constants.REQUIRED_DOCUMENT_STATUS_PROVIDED"
                          class="required-document-status-icon text-white bg-success rounded-circle d-inline-flex align-items-center justify-content-center fs-6 p-1"
                        >
                          check
                        </mat-icon>
                        <mat-icon
                          *ngIf="requiredDocument.status === constants.REQUIRED_DOCUMENT_STATUS_MISSING"
                          class="required-document-status-icon text-white bg-danger rounded-circle d-inline-flex align-items-center justify-content-center fs-6 p-1"
                        >
                          priority_high
                        </mat-icon>
                        <div class="fw-bold">{{requiredDocument.label}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" *ngIf="canUploadFiles() === true">
              <div class="col-12">
                <div class="row">
                  <div class="col-auto">
                    <mat-icon class="icon">attach_file</mat-icon>
                  </div>
                  <div class="col ps-4 pt-1">
                    <div class="card-subtitle">Přiložte dokumenty</div>
                    <div class="upload-form text-center text-muted">
                      <app-online-inspection-upload-photos [task]="task"></app-online-inspection-upload-photos>
                      <p>{{"portal.onlineTaskInspection.fileUploadRequirements" | translate}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="canUploadFiles() === false">
              <div class="card-subtitle">{{"form.validators.cantUploadFilesViaSmsInspection" | translate}}</div>
            </div>

            <div *ngIf="showSentAttachmentButton() === true">
              <hr class="mt-5 mb-4">

              <div class="d-flex justify-content-center">
                <button
                  type="button"
                  class="confirm-online-inspection"
                  [disabled]="isSubmittingOnlineInspection"
                  (click)="onlineTaskInspectionDone()">
                  <mat-icon>done</mat-icon>
                  <span>{{
                    isSubmittingOnlineInspection
                    ? ('portal.onlineTaskInspection.submitting' | translate) + '…'
                    : ('portal.onlineTaskInspection.submitDocuments' | translate) }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
